const REFERRER_META_SELECTOR = 'meta[name="referrer"]';

/** Keeps invitation bearer URLs out of referrer headers while a join route is active. */
export function enforceJoinRoutePrivacy(documentRef: Document): () => void {
  const existing = documentRef.head.querySelector<HTMLMetaElement>(REFERRER_META_SELECTOR);
  const meta = existing ?? documentRef.createElement('meta');
  const previousContent = existing?.content;

  if (!existing) {
    meta.name = 'referrer';
    documentRef.head.prepend(meta);
  }
  meta.content = 'no-referrer';

  return (): void => {
    if (!existing) {
      meta.remove();
      return;
    }
    meta.content = previousContent ?? '';
  };
}
